// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import DashboardCircleOutlinedSvg from "@fishx/icons-svg/es/asn/DashboardCircleOutlined";
import FishxIcon from '../components/FishxIcon';

var DashboardCircleOutlined = function DashboardCircleOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: DashboardCircleOutlinedSvg
  }));
};

DashboardCircleOutlined.displayName = 'DashboardCircleOutlined';
export default React.forwardRef(DashboardCircleOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/DashboardCircleOutlined.js
// module id = 2372
// module chunks = 0